export const DetailsTableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Código',
                    type: 'text',
                    key: 'code',
                },
                {
                    title: 'Tipo',
                    type: 'custom-html',
                    key: 'evaluator_type',
                    isVisible: true,
                    modifier: (item) => {
                        return item.value
                    }
                },
                {
                    title: 'Area',
                    type: 'custom-html',
                    key: 'area',
                    isVisible: true,
                    modifier: (item) => {
                        return item.name
                    }
                },
                {
                    title: 'Alcance',
                    type: 'custom-html',
                    key: 'evaluator_scope',
                    isVisible: true,
                    modifier: (item) => {
                        if (item)
                            return item.scope
                        else 
                            return 'N/A'
                    }
                },
                {
                    title: 'Estatus',
                    type: 'custom-html',
                    key: 'is_active',
                    isVisible: true,
                    modifier: (item) => {
                        let className = 'success';
                        let status = 'Habilitado';
                        if (item == 0) {
                            className = 'danger';
                            status = 'Inhabilitado';
                        }
                        return `<span class="badge badge-sm badge-pill badge-${className}">${status}</span>`;
                    }
                },
            ],
            actionObj: {
                title: 'Acciones',
                type: 'action',
            }
        }
    },
}